import _ from "lodash";

export const BLEED_LINE = _.isUndefined(process.env.REACT_APP_BLEED_LINE) ? 3 : +process.env.REACT_APP_BLEED_LINE;
export const SAFETY_LINE = _.isUndefined(process.env.REACT_APP_SAFETY_LINE) ? 3 : +process.env.REACT_APP_SAFETY_LINE;
export const PARENT_SITE_ORIGIN = (process.env.REACT_APP_PARENT_SITE_ORIGIN || '').split(',').filter(o => !!o);
// Public origin (scheme + host [+ port]) where the backend is reachable from the
// outside, e.g. https://kdpldev.fourpees.com. Set ONLY the origin in
// REACT_APP_REPORT_URL — the fixed reports path below is appended in code. A
// trailing slash is tolerated.
export const REPORT_ORIGIN = (process.env.REACT_APP_REPORT_URL || 'http://localhost:5000').replace(/\/+$/, '');
export const REPORTS_PATH = 'api/kdpl-preflight-service/reports';
// Full base for building public report file URLs: <origin>/api/kdpl-preflight-service/reports
export const REPORT_URL = `${REPORT_ORIGIN}/${REPORTS_PATH}`;
export const SCROLL_STEP = 5;
export const SHOW_SHAPE_DIMENSIONS_INPUTS = process.env.REACT_APP_SHOW_SHAPE_SIZE_INPUTS === 'true' || false;
export const SHOW_SNAP_TOGGLE = _.isUndefined(process.env.REACT_APP_SHOW_SNAP_TOGGLE) ? true : process.env.REACT_APP_SHOW_SNAP_TOGGLE === 'true';
